import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../Styles/AdminLogin.css";

export default function AdminLogin() {

const navigate = useNavigate();

const [email, setEmail] = useState("");
const [password, setPassword] = useState("");

const handleLogin = async (e) => {
e.preventDefault();

try {

const res = await fetch("https://lifetimeinfotech.in/backend/login.php", {
method: "POST",
headers: {
"Content-Type": "application/json",
},
body: JSON.stringify({
email,
password
})
});

const data = await res.json();

if(data.status === "success"){
localStorage.setItem("adminAuth", "true");
navigate("/lifetimeMyAdmin/dashboard");
}
else{
alert("Invalid Credentials");
}

} catch (error) {
console.log(error);
}

};

return (

<div className="admin-login">

<form onSubmit={handleLogin}>
<h2>Admin Login</h2>

<input
type="email"
placeholder="Email"
value={email}
onChange={(e)=>setEmail(e.target.value)}
required
/>

<input
type="password"
placeholder="Password"
value={password}
onChange={(e)=>setPassword(e.target.value)}
required
/>

<button type="submit">
Login
</button>

</form>

</div>

);

}